"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableViews.default;
  }
});
Object.defineProperty(exports, "SwipeableViewsContext", {
  enumerable: true,
  get: function get() {
    return _SwipeableViews.SwipeableViewsContext;
  }
});

var _SwipeableViews = _interopRequireWildcard(require("./SwipeableViews"));